import { createAsyncThunk } from '@reduxjs/toolkit';
import * as API from './apis';
import Swal from 'sweetalert2';

export const getAllDrawersDivisions = createAsyncThunk(
  'DrawersDivisions/getAllDrawersDivisions',
  async (filter: any) => {
    try {
      const res: any = await API.getAllDrawersDivisions({ filter });
      return res.data.drawers_divisions;
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Hubo un error al cargar los datos',
        text: 'intenta de nuevo',
      });
      throw error;
    }
  }
);
